import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'hourminute'
})
export class HourminutePipe implements PipeTransform {
    transform(value: string | null | undefined): string {
        if (!value) return '';
        return value.substring(0, 5);
    }
}
